export var DEFAULT_WORK_DAY_TYPE_CODE = 'W';
export var MAIN_DATA_INDEX = 0;
export var CORNER_DATA_INDEX = 1;
export var WORK_DAY_TYPE = 'W';
export var NO_DATA_DAY_TYPE = 'D';
export var SHIFT_LABEL_LIMIT = 5;
export var STATUSES = ['negative', 'warning', 'positive', 'success'];
export var FACT_SECTION_CODE = 'F';
export var MAIN_SECTION_CODE = 'M';
export var ADDITION_SECTION_CODE = 'A';
export var FACT_TABLE_NAME = 'factTabel';
export var DEFAULT_LEGENDS = ['predict_cashier_needs!all', 'real_cashiers!all'];
export var MODAL_EVENTS = ['AutoschedulingComplete', 'AutoschedulingDelete'];
export var SHIFT_CONTAINER_BY_SCROLL_LEFT = 4;
export var SHIFT_CONTAINER_WIDTH = 192.75;
export var TICKED_PREDICT = 'predict_cashier_needs';
export var TICKED_CASHIERS = 'real_cashiers';
export var TICKED_RESIST = '!';
export var TICKED_PREDICT_WITH_RESIST = TICKED_PREDICT + TICKED_RESIST;
export var TICKED_CASHIERS_WITH_RESIST = TICKED_CASHIERS + TICKED_RESIST;
export var VIRTUAL_SCROLL_THRESHOLD = 75;
export var EMPLOYEE_EMPLOYMENT_STATUSES = 'employee';
export var NETWORK_EMPLOYMENT_STATUSES = 'network';
export var INTERNAL_EMPLOYMENT_STATUSES = 'internal';
export var OUTSOURCE_EMPLOYMENT_STATUSES = 'outsource';
export var EMPLOYEE_FETCH_CHUNK_SIZE = 500;